import { FormBuilder } from '@angular/forms';
import { AvpCustomAdaptor } from '../../../base/shared/syncfusion/avp-custom-adaptor';
import { DataManager } from '@syncfusion/ej2-data';
import { userManagementRoute } from '../../../core/routing/route-names';
import { Router } from '@angular/router';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CommandClickEventArgs, CommandModel, GridModule } from '@syncfusion/ej2-angular-grids';
import { GridConstantsFactory } from 'src/app/base/shared/syncfusion/grid-constants-factory';
import { DynamicGridBaseComponent } from 'src/app/base/shared/grid-base/dynamic-grid-base.component';
import { ClientDTO } from 'src/app/base/models/models.swagger.generated';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';
import { SfCommandButtonType } from 'src/app/base/models/syncfusion-data';
import { DynamicEditFormComponent } from 'src/app/base/shared/dynamic/dynamic-edit-form.component';
import { clientDynamicDefinition } from './client-dynamic.definition';
import { ToolbarModule } from '@syncfusion/ej2-angular-navigations';
import { CheckBoxModule } from '@syncfusion/ej2-angular-buttons';
import { SearchFieldComponent } from '../../../base/shared/search-field/search-field.component';
import { EnumFilterService } from 'src/app/base/services/enum-filter.service';
import { ClientAdministrationService } from '../client-administration/client-administration.service';

@Component({
    selector: 'app-dynamic-client-administration',
    templateUrl: './dynamic-client-administration.component.html',
    styleUrls: ['./dynamic-client-administration.component.scss'],
    imports: [SearchFieldComponent, CheckBoxModule, GridModule, ToolbarModule, DynamicEditFormComponent, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [ClientAdministrationService]
})
export class DynamicClientAdministrationComponent extends DynamicGridBaseComponent<typeof clientDynamicDefinition> implements OnInit {

  constructor(private clientAdministrationService: ClientAdministrationService,
              private router: Router,
              fb: FormBuilder,
              translateService: TranslateService,
              private spinnerService: SpinnerService,
              enumFilterService: EnumFilterService) {
    super(clientDynamicDefinition, fb, null, translateService, clientAdministrationService, enumFilterService);
    this.gridCommands = [...GridConstantsFactory.createStandardGridCommands(), {
      type: 'None',
      title: this.translateService.instant('i18n.domain.client-administration.overview.tooltips.add-users'),
      buttonOption:
      {
        cssClass: 'icon-btn',
        iconCss: 'icon-user--multiple e-icons'
      }
    } as CommandModel];
    this.searchOptions = {fields: this.crudDefinition.grid.searchFields};
  }

  public ngOnInit() {
    this.data = new DataManager({
      adaptor: new AvpCustomAdaptor(this.clientAdministrationService, this.spinnerService),
    });
    this.isActiveColumnName = 'isActive';
    this.editDialogTitle = 'i18n.domain.client-administration.overview.edit-dialog-title';
    this.addDialogTitle = 'i18n.domain.client-administration.overview.tooltips.add';
  }

  public commandClick(args: CommandClickEventArgs) {
    if (args.commandColumn?.type === SfCommandButtonType.None) {
      const clientId = ((args.rowData) as any).id;
      this.router.navigate([userManagementRoute], {queryParams: { clientId }});
    }
  }

  protected override addObjectCompare(addedObject: ClientDTO, rowObject: ClientDTO) : boolean {
    if (this.addIndexFindColumnName) {
      return addedObject.name === rowObject.name && addedObject.address === rowObject.address && addedObject.zip === rowObject.zip;
    }
    return false;
  }

  protected getEditDialogTitleParams(rowData: any): object {
    return {param: rowData.name};
  }
}
